/*
USE MuellerHomeowner
GO

SET NOCOUNT ON
SET TRANSACTION ISOLATION LEVEL READ UNCOMMITTED

SELECT EnumVal FROM(
SELECT '/** @description ' + d.Name + ' : ' + r.name + ' ' + CHAR(42) + '/
export const ' + r.Code + ' = ' + CAST(r.Id as varchar(50)) +';
' as EnumVal, ROW_NUMBER() OVER (ORDER BY r.Code) AS EnumSort
FROM    MuellerGlobalData.dbo.EmployeeRoles r
LEFT OUTER JOIN MuellerGlobalData.dbo.EmployeeDepartments d
	ON r.EmployeeDepartmentId = d.Id

UNION ALL

SELECT '
/** @description Unknown employee role ' + CHAR(42) + '/
export const UNKNOWN = -1;
' as EnumVal, 9999999 as EnumSort
) x
ORDER BY EnumSort
*/

/** @description Accounting : Accounting Associate */
export const ACCOUNTING_ASSOCIATE = 1;
/** @description Accounting : Accounting Manager */
export const ACCOUNTING_MANAGER = 2;
/** @description Valuation Field Service : Broker Engagement Rep */
export const BROKER_ENGAGEMENT_REP = 60;
/** @description Business Development : Business Development Director */
export const BUSINESSDEVELOPMENT_DIRECTOR = 50;
/** @description Business Development : Business Development Manager */
export const BUSINESSDEVELOPMENT_MANAGER = 51;
/** @description Business Development : Business Development Vice President */
export const BUSINESSDEVELOPMENT_VP = 49;
/** @description Business Operations : BusOp Agent */
export const BUSOP_AGENT = 3;
/** @description Business Operations : BusOp Assistant VP */
export const BUSOP_ASSISTANT_VP = 56;
/** @description Customer Service : BusOp Customer Service Associate */
export const BUSOP_CUSTOMER_SERVICE_ASSOCIATE = 6;
/** @description Customer Service : BusOp Customer Service Manager */
export const BUSOP_CUSTOMER_SERVICE_MANAGER = 7;
/** @description Business Operations : BusOp Director */
export const BUSOP_DIRECTOR = 4;
/** @description Business Operations : BusOp Manager */
export const BUSOP_MANAGER = 5;
/** @description Customer Service : Clerical Associate */
export const CLERICAL_ASSOCIATE = 8;
/** @description Customer Service : Clerical Director */
export const CLERICAL_DIRECTOR = 45;
/** @description Customer Service : Clerical Manager */
export const CLERICAL_MANAGER = 9;
/** @description Customer Service : Customer Experience Director */
export const CUSTOMER_EXPERIENCE_DIRECTOR = 74;
/** @description Customer Service : Customer Experience Manager */
export const CUSTOMER_EXPERIENCE_MANAGER = 71;
/** @description Customer Service : Customer Experience Rep */
export const CUSTOMER_EXPERIENCE_REP = 69;
/** @description Customer Service : Customer Service Associate */
export const CUSTOMER_SERVICE_ASSOCIATE = 62;
/** @description Customer Service : Customer Service Manager */
export const CUSTOMER_SERVICE_MANAGER = 63;
/** @description Executive : Executive Associate */
export const EXECUTIVE_ASSOCIATE = 10;
/** @description Executive : Executive Director */
export const EXECUTIVE_DIRECTOR = 48;
/** @description Executive : Executive Manager */
export const EXECUTIVE_MANAGER = 11;
/** @description Executive : Executive President */
export const EXECUTIVE_PRESIDENT = 12;
/** @description Executive : Executive Vice President */
export const EXECUTIVE_VICE_PRESIDENT = 13;
/** @description Field Services : Field Development Manager */
export const FIELD_DEVELOPMENT_MANAGER = 68;
/** @description Field Services : Field Logistic Coordinator */
export const FIELD_LOGISTIC_COORDINATOR = 14;
/** @description Field Services : Operations AVP */
export const FIELD_OPERATIONS_AVP = 66;
/** @description Field Services : Operations Director */
export const FIELD_OPERATIONS_DIRECTOR = 65;
/** @description Field Services : Operations Manager */
export const FIELD_OPERATIONS_MANAGER = 64;
/** @description Field Services : Operations VP */
export const FIELD_OPERATIONS_VP = 67;
/** @description Field Services : Field Service Assistant VP */
export const FIELD_SERVICE_ASSISTANT_VP = 57;
/** @description Field Services : Field Service Director */
export const FIELD_SERVICE_DIRECTOR = 15;
/** @description Field Services : Field Service Rep */
export const FIELD_SERVICE_REP = 16;
/** @description Field Services : Field Service Training Coordinator */
export const FIELD_SERVICE_TRAINING_COORDINATOR = 61;
/** @description Human Resources : Human Resource Associate */
export const HUMAN_RESOURCE_ASSOCIATE = 17;
/** @description Human Resources : Human Resource Director */
export const HUMAN_RESOURCE_DIRECTOR = 18;
/** @description Human Resources : Human Resource Manager */
export const HUMAN_RESOURCE_MANAGER = 55;
/** @description Information Technology : IT Director */
export const IT_DIRECTOR = 19;
/** @description Information Technology : IT Junior Software Developer */
export const IT_JUNIOR_SOFTWARE_DEVELOPER = 20;
/** @description Information Technology : IT Manager */
export const IT_MANAGER = 21;
/** @description Information Technology : IT Project Manager */
export const IT_PROJECT_MANAGER = 22;
/** @description Information Technology : IT Software Developer */
export const IT_SOFTWARE_DEVELOPER = 23;
/** @description Information Technology : IT Technical Support */
export const IT_TECHNICAL_SUPPORT = 24;
/** @description Information Technology : IT Vice President */
export const IT_VICE_PRESIDENT = 25;
/** @description Field Services : Lender Logistics Manager */
export const LENDER_LOGISTICS_MANAGER = 72;
/** @description Loss Draft : Loss Draft Associate */
export const LOSS_DRAFT_ASSOCIATE = 26;
/** @description Loss Draft : Loss Draft Director */
export const LOSS_DRAFT_DIRECTOR = 46;
/** @description Loss Draft : Loss Draft Manager */
export const LOSS_DRAFT_MANAGER = 47;
/** @description Business Operations : Quality Development Manager */
export const QUALITY_DEVELOPMENT_MANAGER = 73;
/** @description Recruiting : Recruiting Associate */
export const RECRUITING_ASSOCIATE = 27;
/** @description Recruiting : Recruiting Director */
export const RECRUITING_DIRECTOR = 52;
/** @description Recruiting : Recruiting Manager */
export const RECRUITING_MANAGER = 28;
/** @description Sales Insurance : Sales Insurance Director */
export const SALES_INSURANCE_DIRECTOR = 29;
/** @description Sales Insurance : Sales Insurance Manager */
export const SALES_INSURANCE_MANAGER = 30;
/** @description Sales Insurance : Sales Insurance Vice President */
export const SALES_INSURANCE_VICE_PRESIDENT = 31;
/** @description Sales Valuations : Sales Valuation Director */
export const SALES_VALUATION_DIRECTOR = 32;
/** @description Sales Valuations : Sales Valuation Vice President */
export const SALES_VALUATION_VICE_PRESIDENT = 33;
/** @description Customer Service : Telephone Agent */
export const TELEPHONE_AGENT = 34;
/** @description Customer Service : Telephone Director */
export const TELEPHONE_DIRECTOR = 35;
/** @description Customer Service : Telephone Manager */
export const TELEPHONE_MANAGER = 36;
/** @description Training : Training Associate */
export const TRAINING_ASSOCIATE = 37;
/** @description Valuation Field Service : Valuation Appraiser */
export const VALUATION_APPRAISER = 40;
/** @description Field Services : Valuation Assistant VP */
export const VALUATION_ASSISTANT_VP = 58;
/** @description Valuation Field Service : Valuation Chief Appraiser */
export const VALUATION_CHIEF_APPRAISER = 41;
/** @description Customer Service : Valuation Customer Service Associate */
export const VALUATION_CUSTOMER_SERVICE_ASSOCIATE = 38;
/** @description Customer Service : Valuation Customer Service Director */
export const VALUATION_CUSTOMER_SERVICE_DIRECTOR = 59;
/** @description Customer Service : Valuation Customer Service Manager */
export const VALUATION_CUSTOMER_SERVICE_MANAGER = 39;
/** @description Field Services : Valuation Director */
export const VALUATION_DIRECTOR = 53;
/** @description Business Operations : Valuation Quality Associate */
export const VALUATION_QUALITY_ASSOCIATE = 43;
/** @description Business Operations : Valuation Quality Manager */
export const VALUATION_QUALITY_MANAGER = 44;
/** @description Valuation Field Service : Valuation Support Rep */
export const VALUATION_SUPPORT_REP = 42;
/** @description Field Services : Valuation Vice President */
export const VALUATION_VICE_PRESIDENT = 54;

/** @description Unknown employee role */
export const UNKNOWN = -1;
